import React, { useEffect, useState } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
export function AmbientBackground() {
  const {
    scrollY
  } = useScroll();
  // Parallax transforms for floating orbs at different speeds
  const y1 = useTransform(scrollY, [0, 5000], [0, -800]);
  const y2 = useTransform(scrollY, [0, 5000], [0, -500]);
  const y3 = useTransform(scrollY, [0, 5000], [0, -1200]);
  const y4 = useTransform(scrollY, [0, 5000], [0, -350]);
  const y5 = useTransform(scrollY, [0, 5000], [0, -900]);
  // Subtle rotation on scroll
  const rotate1 = useTransform(scrollY, [0, 5000], [0, 45]);
  const rotate2 = useTransform(scrollY, [0, 5000], [0, -30]);
  return <div className="fixed inset-0 z-0 pointer-events-none overflow-hidden" data-id="element-101">
      {/* Noise texture overlay */}
      <div className="absolute inset-0 z-50 opacity-[0.03]" style={{
      backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noise)' opacity='1'/%3E%3C/svg%3E")`,
      backgroundRepeat: 'repeat',
      backgroundSize: '128px 128px'
    }} data-id="element-102" />

      {/* Large ambient orb — top right, warm */}
      <motion.div style={{
      y: y1,
      rotate: rotate1
    }} className="absolute -top-[200px] -right-[200px] w-[700px] h-[700px] rounded-full" data-id="element-103">
        <div className="w-full h-full rounded-full bg-brand-orange/[0.03] blur-[120px]" data-id="element-104" />
      </motion.div>

      {/* Medium orb — left side, cool white */}
      <motion.div style={{
      y: y2
    }} className="absolute top-[600px] -left-[150px] w-[500px] h-[500px] rounded-full" data-id="element-105">
        <div className="w-full h-full rounded-full bg-white/[0.02] blur-[100px]" data-id="element-106" />
      </motion.div>

      {/* Small accent orb — center, brand orange hint */}
      <motion.div style={{
      y: y3,
      rotate: rotate2
    }} className="absolute top-[1400px] right-[10%] w-[400px] h-[400px] rounded-full" data-id="element-107">
        <div className="w-full h-full rounded-full bg-brand-orange/[0.04] blur-[100px]" data-id="element-108" />
      </motion.div>

      {/* Deep orb — lower page, subtle blue accent */}
      <motion.div style={{
      y: y4
    }} className="absolute top-[2400px] -left-[100px] w-[600px] h-[600px] rounded-full" data-id="element-109">
        <div className="w-full h-full rounded-full bg-brand-blue/[0.02] blur-[120px]" data-id="element-110" />
      </motion.div>

      {/* Bottom warm glow */}
      <motion.div style={{
      y: y5
    }} className="absolute top-[3500px] right-[20%] w-[500px] h-[500px] rounded-full" data-id="element-111">
        <div className="w-full h-full rounded-full bg-brand-orange/[0.03] blur-[100px]" data-id="element-112" />
      </motion.div>

      {/* Floating glass shards — very subtle refractive elements */}
      <motion.div style={{
      y: useTransform(scrollY, [0, 5000], [0, -600])
    }} className="absolute top-[800px] left-[15%] w-[1px] h-[300px] bg-gradient-to-b from-transparent via-white/[0.06] to-transparent rotate-[15deg]" data-id="element-113" />
      <motion.div style={{
      y: useTransform(scrollY, [0, 5000], [0, -400])
    }} className="absolute top-[1800px] right-[25%] w-[1px] h-[200px] bg-gradient-to-b from-transparent via-white/[0.04] to-transparent -rotate-[20deg]" data-id="element-114" />
      <motion.div style={{
      y: useTransform(scrollY, [0, 5000], [0, -700])
    }} className="absolute top-[3000px] left-[40%] w-[1px] h-[250px] bg-gradient-to-b from-transparent via-brand-orange/[0.06] to-transparent rotate-[8deg]" data-id="element-115" />
    </div>;
}